export const ATTACHMENT_GET_V1            = buildWebsocketEndpoint('/v1/attachment.get');
export const MESSAGE_GET_V1               = buildWebsocketEndpoint('/v1/message.get');
export const MARK_AS_READ_V1              = buildWebsocketEndpoint('/v1/message.markAsRead');
export const CHAT_GET_V1                  = buildWebsocketEndpoint('/v1/chat.get');
export const CHAT_SET_TYPING_V1           = buildWebsocketEndpoint('/v1/chat.setTyping');
export const DM_START_V1                  = buildWebsocketEndpoint('/v1/chat.startDirectMessage');
export const CHANNEL_START_V1             = buildWebsocketEndpoint('/v1/chat.startChannel');
export const CHANNEL_ADD_USERS_V1         = buildWebsocketEndpoint('/v1/chat.addUsersToChannel');
export const CHANNEL_JOIN_V1              = buildWebsocketEndpoint('/v1/chat.joinChannel');
export const HIDE_CHAT_V1                 = buildWebsocketEndpoint('/v1/chat.hide');
export const CHANNEL_LEAVE_V1             = buildWebsocketEndpoint('/v1/chat.leaveChannel');
export const GET_UNREAD_COUNT_V1          = buildWebsocketEndpoint('/v1/chat.getUnreadCount');
export const WEBSOCKET_PING_V1            = buildWebsocketEndpoint('/v1/ping');

/**
 * Websocket connections are initiated with an HTTP request
 */
export const WEBSOCKET_CONNECT_V1               = buildHttpEndpoint('/v1/connect');
export const IDENTITY_GET_V1                    = buildHttpEndpoint('/v1/identity');
export const CHAT_SEND_V1                       = buildHttpEndpoint('/v1/chat.send');
export const ATTACHMENT_UPLOAD_V1               = buildHttpEndpoint('/v1/attachment.upload');
export const ATTACHMENT_DOWNLOAD_V1             = buildHttpEndpoint('/v1/attachment.download');
export const ATTACHMENT_VIDEO_IMAGE_DOWNLOAD_V1 = buildHttpEndpoint('/v1/attachment.videoImageDownload');
export const LOCAL_LOGOUT                       = buildHttpEndpoint('/localLogout');
export const LOGOUT                             = buildHttpEndpoint('/logout');
export const SESSION_CONFIG                     = buildHttpEndpoint('/v1/config.session');

/**
 * App Start
 */
export const CHAT_GET_ALL_V1                    = buildHttpEndpoint('/v1/chat.getAll');
export const CHAT_GET_PUBLIC_CHANNELS_V1        = buildHttpEndpoint('/v1/chat.getPublicChannels');
export const USER_SEARCH_V1                     = buildHttpEndpoint('/v1/user.search');

// Oauth Login URL for Members only
export const MEMBER_LOGIN                       = buildHttpEndpoint('/');

// Unsecured endpoint that is used on initial app load to see if the user is authenticated or not
export const AUTHENTICATED                      = buildHttpEndpoint('/authenticated');

export const PDF_EXPORT                         = buildHttpEndpoint('/v1/pdf.export');

export const INBOX_MESSENGER_AUTH_ERROR_PAGE    = buildHttpEndpoint('/customError?error_code=666');
/**
 * Create an absolute websocket API URI
 * @param {string} relativePath relative endpoint path
 * @return {string} absolute URI
 */
function buildWebsocketEndpoint(relativePath) {
  // Prefix is determined by the server-side STOMP configuration
  const wsApiContext = '/app';
  return wsApiContext + relativePath;
}

/**
 * Create an absolute HTTP API URI
 * @param {string} relativePath relative endpoint path
 * @return {string} absolute URI
 */
function buildHttpEndpoint(relativePath) {
  const servletContext = '/api';
  return servletContext + relativePath;
}
